import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from "./index.module.less"

declare type IProps = {
    content: string;
    className?: string;
    isUseDefaultClassName?: boolean;
}

// eslint-disable-next-line react/display-name
const MarkdownHtml = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const {
        content,
        className,
        isUseDefaultClassName = true
    } = props

    return (
        <div
            ref={ref}
            className={cn(className, { [styles.markdown]: isUseDefaultClassName })}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    )
})

export default React.memo(MarkdownHtml)
